module.exports = __webpack_public_path__ + "files/3dcbde31159844734d258d156a4a799c.gif";